import React from "react";
import { Switch, Icon } from "../";

const DeliveryGroupCard = ({
  group,
  onViewDetails,
  onToggleStatus,
  isToggling,
}) => {
  const getTypeLabel = (type) => {
    if (type === 0) return "In-house drivers";
    if (type === 1) return "Delivery companies";
    return "Unknown";
  };

  const borderColor = group?.enabled
    ? "border-green-500/50 hover:border-green-500/70"
    : "border-red-500/50 hover:border-red-500/70";

  return (
    <div
      onClick={() => onViewDetails && onViewDetails(group)}
      className={`rounded-lg border-2 bg-gray-900 ${borderColor} cursor-pointer p-4 transition-colors`}
    >
      <div className="flex items-center justify-between">
        <div className="min-w-0 flex-1">
          <div className="mb-2">
            <h3 className="truncate font-medium text-white">
              {group?.name || "Unknown"}
            </h3>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Tag" className="h-4 w-4 flex-shrink-0 text-gray-400" />
            <span className="text-sm text-gray-400">
              {getTypeLabel(group?.type)}
            </span>
          </div>
        </div>
        <div
          className="ml-4 flex flex-shrink-0 items-center space-x-2"
          onClick={(e) => e.stopPropagation()}
        >
          <Switch
            checked={!!group?.enabled}
            onCheckedChange={() =>
              onToggleStatus && onToggleStatus(group.id, !group?.enabled)
            }
            disabled={isToggling}
          />
        </div>
      </div>
    </div>
  );
};

export default DeliveryGroupCard;
